import React, { Component } from "react";
import { applyDataTable, destroyDataTable } from '../../../custom/dataTable';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg";
import Autocomplete from "react-autocomplete"
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { getlookupdocinfo, getlookuppageinfo } from "../../../../actions/MasterDataAction";
import Active from "../../../../assets/img/svg/active.svg";
import Deactive from "../../../../assets/img/svg/deactive.svg";
import { getuserdata } from "../../../../actions/UserManageAction.js";

class LViewAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            User_Table: [],
            active: [],
            deactive: [],
            Name: [],
            Email: [],
            index:1,
            Number: [],
            Projects: [],
            ProjectFilter: "",
            searchData: {
                "PageNumber": 1,
                "PageSize": 100,
                "UserId": 0,
                "Name": "",
                "Email": "",
                "ContactNumber": "",
                "Status": "",
                "RoleId": 1,
                "RoleName": "",
                "CreatedBy": "",
                "CreatedDate": "",
                "ProjectIds": [],
                "ProjectList": [],
                "SortBy":'emailid',
                "SortOrder":'asc'
            },
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.props.dispatch({ type: "USER_TABLE", data: [] });
        this.dataTable(this.state.searchData)
        this.getProjectList()
        localStorage.removeItem("EditUser")
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    getProjectList = (data) => {
        let apiUrl = API.ADDEDIT_PROJECT + 'ProjectList';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (response?.data?.length > 0) {
                        this.state.Projects = response.data;
                        this.setState({})
                    }
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTable = (data) => {
        let apiUrl = API.USER_MANAGEMENT;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.User_Table = [];
                    this.state.Name = [];
                    this.state.Email = [];
                    this.state.Number = [];
                    this.setState({})
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "") {
                                this.state.Name.push(i.Name);
                            }
                            if (i.Email != null && i.Email != undefined && i.Email != "") {
                                this.state.Email.push(i.Email);
                            }
                            if (i.ContactNumber != null && i.ContactNumber != undefined && i.ContactNumber != "") {
                                this.state.Number.push(i.ContactNumber);
                            }
                        })
                        this.setState({})
                    }
                    destroyDataTable("staffTable");
                    this.props.dispatch({ type: "USER_TABLE", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0] }], "", "", "","",[this.state.index,this.state.searchData.SortOrder])
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    dataTable1 = (data) => {
        let apiUrl = API.USER_MANAGEMENT;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.User_Table = [];
                    this.state.Name = [];
                    this.state.Email = [];
                    this.state.Number = [];
                    this.setState({})
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "") {
                                this.state.Name.push(i.Name);
                            }
                            if (i.Email != null && i.Email != undefined && i.Email != "") {
                                this.state.Email.push(i.Email);
                            }
                            if (i.ContactNumber != null && i.ContactNumber != undefined && i.ContactNumber != "") {
                                this.state.Number.push(i.ContactNumber);
                            }
                        })
                        this.setState({})
                    }
                    destroyDataTable("staffTable");
                    this.props.dispatch({ type: "USER_TABLE", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0] }], "", "", "","",[this.state.index,this.state.searchData.SortOrder])
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#UADMIN1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#UserMngt0 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#UserMngt00").addClass("d-none");
        $("#UserMngt00").removeClass("d-block");
        this.props.dispatch({ type: "USER_TABLE", data: [] });
    }

    sidebar = () => {
        this.props.navigate("/SidebarUser");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#UADMIN1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#UserMngt0 .MuiListItemText-primary").addClass("fw-bolder");
        $("#UserMngt00").removeClass("d-none");
        $("#UserMngt00").addClass("d-block");
        $("#MOPAT .MuiListItemText-primary").addClass("fw-bolder")
        $("#MOPA").addClass("active-color")
    }

    AddNew = () => {
        this.props.navigate("/usermanagement/admin/add")
    };

    EditPage = () => {
        let temp = []
        this.state.DownDelete.map((i) => {
            if (i.check == true) {
                temp.push(i)
            }
        })
        if (temp.length == 1) {
            this.props.navigate("/usermanagement/admin/edit")
        }
    };

    activedeactive = (data) => {
        let apiUrl = API.CHANGE_USERSTATUS;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    // let temp = {
                    //     "PageNumber": 1,
                    //     "PageSize": 100,
                    //     "UserId": 0,
                    //     "Name": "",
                    //     "Email": "",
                    //     "ContactNumber": "",
                    //     "Status": "",
                    //     "RoleId": 1,
                    //     "RoleName": "",
                    //     "CreatedBy": "",
                    //     "CreatedDate": "",
                    //     "ProjectIds": [],
                    //     "ProjectList": []
                    // };
                    // this.state.searchData = temp;
                    this.state.active = [];
                    this.state.deactive = [];
                    this.setState({})
                    $('input[type=checkbox]').prop('checked', false);
                    this.props.dispatch(getuserdata(this.state.searchData))
                    this.props.navigate(`/usermanagement/admin`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    handleProjectNameSearchChange = (e, node) => {
        if (node == "ProjectName") {
            this.state.searchData.ProjectIds = [];
            this.state.ProjectFilter = e.target.value;
            let idfilter = this.state.Projects.filter(val => val.Name == e.target.value)
            idfilter.map((i) => {
                this.state.searchData.ProjectIds.push(i.Id)
            })
        }
        else {
            this.state.searchData[node] = e.target.value;
        }
        this.setState({});
    };

    handleProjectNameSelectChange = (e, node) => {
        if (node == "ProjectName") {
            this.state.searchData.ProjectIds = [];
            this.state.ProjectFilter = e;
            let idfilter = this.state.Projects.filter(val => val.Name == e)
            idfilter.map((i) => {
                this.state.searchData.ProjectIds.push(i.Id)
            })
        }
        else {
            this.state.searchData[node] = e;
        }
        this.setState({});
    };

    projectnew = (id) => {
        this.props.navigate(`http://localhost:3000/basicinformation/id`)
    }

    handleCheckboxChange = (e, x, status) => {
        let temp = {
            "Id": x,
            "Status": status
        }
        if (status == false) {
            if (e.target.checked == true) {
                this.state.active.push(temp)
                this.setState({})
            }
            else {
                if (this.state.active.length > 0) {
                    this.state.active.map((i, ind) => {
                        if (i.Id == x) {
                            this.state.active.splice(ind, 1)
                            this.setState({})
                        }
                    })
                }
            }
        }
        else {
            if (e.target.checked == true) {
                this.state.deactive.push(temp)
                this.setState({})
            }
            else {
                if (this.state.deactive.length > 0) {
                    this.state.deactive.map((i, ind) => {
                        if (i.Id == x) {
                            this.state.deactive.splice(ind, 1)
                            this.setState({})
                        }
                    })
                }
            }
        }
        this.setState({})
    };

    EditUser = (email) => {
        localStorage.setItem("EditUser", email)
        this.props.navigate(`/usermanagement/admin/edit`)
    }

    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            "PageNumber": 1,
            "PageSize": 100,
            "UserId": 0,
            "Name": "",
            "Email": "",
            "ContactNumber": "",
            "Status": "",
            "RoleId": 1,
            "RoleName": "",
            "CreatedBy": "",
            "CreatedDate": "",
            "ProjectIds": [],
            "ProjectList": [],
            "SortBy":'emailid',
            "SortOrder":'asc'
        };
        this.state.searchData = input;
        this.state.ProjectFilter = "";
        this.setState({});
        // this.props.dispatch(getuserdata(this.state.searchData))
    };

    filterSearch() {
        this.state.index=1;
        this.state.searchData.SortBy='emailid'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        this.dataTable(this.state.searchData)
    };

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.dataTable(this.state.searchData)
    }
    handleSort = (data, ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data
        this.state.searchData.PageNumber = 1;
        this.setState({
            index: ind,
        });
        this.dataTable1(this.state.searchData);
    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id={"UADMIN" + 1} className='textNaviIcon' primary="Users" />
                                            <NavigateNextIcon id="UADMIN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Admin</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }

                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}  pl-3`} disabled={this.state.hide && this.state.hide.length == 1 ? false : true} ><img src={Active} style={{ marginTop: '-4px', opacity: this.state.hide && this.state.hide.length == 1 ? '' : '0.5' }}></img>&nbsp;Active</button></td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}`} data-target="#deletepopup" disabled={this.state.hide && this.state.hide.length > 0 ? false : true} data-toggle="modal"><img src={Deactive} style={{ marginTop: '-4px', opacity: this.state.hide && this.state.hide.length > 0 ? '' : '0.5' }}></img>&nbsp;Deactive</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddNew}><i className="fa fa-plus pr-2" style={{ color: "#00838F" }}></i>Add New</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <>
                            <div className="row  border-bottom">
                                <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">
                                    {/* <button className={classes.button} onClick={this.EditPage} disabled="true" style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.hide.length == 1 ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                    <button className={classes.button} data-target="#deletepopup" disabled="true" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.hide.length > 0 ? '' : '0.5' }}></img>&nbsp;Delete</button> */}
                                    <button className={classes.button} onClick={() => this.activedeactive(this.state.deactive)} disabled={this.state.deactive && this.state.deactive.length > 0 ? false : true} style={{ minWidth: '90px' }}><img src={Active} style={{ marginTop: '-4px', opacity: this.state.deactive.length > 0 ? '' : '0.5' }}></img>&nbsp;Activate</button>
                                    <button className={classes.button} onClick={() => this.activedeactive(this.state.active)} disabled={this.state.active && this.state.active.length > 0 ? false : true} style={{ minWidth: '90px' }}><img src={Deactive} style={{ marginTop: '-4px', opacity: this.state.active.length > 0 ? '' : '0.5' }}></img>&nbsp;Deactivate</button>
                                    <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                        <button className={classes.button} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F" }}></i>Add New</button>
                                    </div>
                                </div>
                            </div>
                        </>}
                    <div className="row pb-4" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Admin</h6>}
                            </div>
                            <div className="col-2 p-2">
                                <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ minWidth: '70px' }}><img src={FilterIcon} />&nbsp;Filter </button>
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                <table id="staffTable" className="table table-borderless">
                                    <thead>
                                        <tr className="table-active border-bottom">
                                            <th className="border-top border-right border-left" width="3%"><span className="fw-bold" style={{ color: "#000000" }}></span></th>
                                            <th className="border-top border-right" width="26%" onClick={() => this.handleSort('emailid', 1)}><span className="fw-bold" style={{ color: "#000000" }}>Email ID</span></th>
                                            <th className="border-top border-right" width="25%" onClick={() => this.handleSort('name', 2)}><span className="fw-bold" style={{ color: "#000000" }}>Name</span></th>
                                            <th className="border-top border-right" width="13%" onClick={() => this.handleSort('contactnumber', 3)}><span className="fw-bold" style={{ color: "#000000" }}>Contact Number</span></th>
                                            <th className="border-top border-right" width="25%" onClick={() => this.handleSort('projects', 4)}><span className="fw-bold" style={{ color: "#000000" }}>Projects</span></th>
                                            <th className="border-top border-right" width="8%"  onClick={() => this.handleSort('status', 5)}><span className="fw-bold" style={{ color: "#000000" }}>Status</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.User_Table?.Data && this.props.User_Table?.Data.length > 0 && this.props.User_Table?.Data.map((i, index) => (<>
                                            <tr className="border-bottom">
                                                <td className="align-middle border-right border-left"><input type="checkbox" style={{ width: "16px", height: "16px" }} onChange={(e) => this.handleCheckboxChange(e, i.UserId, i.Status == "Active" ? false : true)} /></td>
                                                <td className="align-middle border-right"><a href="#" onClick={() => { this.EditUser(i.UserId) }}>{i.Email}</a></td>
                                                <td className="align-middle border-right">{i.Name}</td>
                                                <td className="align-middle border-right">{i.ContactNumber}</td>
                                                <td className="align-middle border-right"><>
                                                    {i.ProjectList && i.ProjectList.map((a) => (<>
                                                        <a href="../basicinformation/edit" target="_blank" onClick={()=> localStorage.setItem("DashId",a.ProjectId)}>{a.ProjectName}</a><br></br>
                                                    </>))}</></td>
                                                <td className="align-middle border-right">{i.Status == "Active" ? "Active" : "Deactive"}</td>
                                            </tr>
                                        </>))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12" onClick={() => this.ResetFilter()}>
                                            <img src={FilterIcon} className="cursorPointer" />&nbsp;<span className="cursorPointer">Reset to default</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4">
                                    <form id="myform">
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Email ID</label></div>
                                            <div className="col-7">
                                                <div className="autocomplete-wrappers">
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.searchData.Email}
                                                        inputProps={{
                                                            placeholder: "Email ID",
                                                        }}
                                                        items={this.state.Email ?? []}
                                                        getItemValue={(item) => item}
                                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdowns d-block" >{item}</div>
                                                        )}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control border-radius"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                    style={{ height: 32, fontSize: 12, color: "#000000" }}
                                                                />
                                                            );
                                                        }}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item}
                                                            </div>
                                                        )}
                                                        onChange={(e) => this.handleProjectNameSearchChange(e, "Email")}
                                                        onSelect={(e) => this.handleProjectNameSelectChange(e, "Email")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Name</label></div>
                                            <div className="col-7">
                                                <div className="autocomplete-wrappers">
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.searchData.Name}
                                                        inputProps={{
                                                            placeholder: "Name",
                                                        }}
                                                        items={this.state.Name ?? []}
                                                        getItemValue={(item) => item}
                                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdowns d-block" >{item}</div>
                                                        )}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control border-radius"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                    style={{ height: 32, fontSize: 12, color: "#000000" }}
                                                                />
                                                            );
                                                        }}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item}
                                                            </div>
                                                        )}
                                                        onChange={(e) => this.handleProjectNameSearchChange(e, "Name")}
                                                        onSelect={(e) => this.handleProjectNameSelectChange(e, "Name")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Contact Number</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="date"
                                                    type="tel"
                                                    maxLength={10}
                                                    placeholder="Contact Number"
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    value={this.state.searchData.ContactNumber}
                                                    onChange={(e) => this.handleProjectNameSearchChange(e, "ContactNumber")}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                                {/* <div className="autocomplete-wrappers">
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.searchData.ContactNumber}
                                                        inputProps={{
                                                            placeholder: "Contact Number",
                                                        }}
                                                        items={this.state.Number ?? []}
                                                        getItemValue={(item) => item}
                                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdowns d-block" >{item}</div>
                                                        )}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control border-radius"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                    style={{ height: 32, fontSize: 12, color: "#000000" }}
                                                                />
                                                            );
                                                        }}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item}
                                                            </div>
                                                        )}
                                                        onChange={(e) => this.handleProjectNameSearchChange(e, "ContactNumber")}
                                                        onSelect={(e) => this.handleProjectNameSelectChange(e, "ContactNumber")}
                                                    />
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Project</label></div>
                                            <div className="col-7">
                                                <div className="autocomplete-wrappers">
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.ProjectFilter}
                                                        inputProps={{
                                                            placeholder: "Project",
                                                        }}
                                                        items={this.state.Projects ?? []}
                                                        getItemValue={(item) => item.Name}
                                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdowns d-block" >{item}</div>
                                                        )}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control border-radius"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                    style={{ height: 32, fontSize: 12, color: "#000000" }}
                                                                />
                                                            );
                                                        }}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item.Name}
                                                            </div>
                                                        )}
                                                        onChange={(e) => this.handleProjectNameSearchChange(e, "ProjectName")}
                                                        onSelect={(e) => this.handleProjectNameSelectChange(e, "ProjectName")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.filterSearch()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div >
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                {/* <div class="modal-header">
                            <h1><i class="bi bi-exclamation-triangle-fill text-warning"></i></h1>
                            <div>
                                <h5 class="fw-bold">Warning</h5>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. </p>
                            </div>
                        </div> */}
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                        {/* <i class="bi bi-check-circle-fill text-success"></i> */}
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNumber == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                        {(this.state.searchData.PageNumber == this.props.User_Table?.Pagination?.TotalPages) || (this.props.User_Table?.Pagination?.TotalPages == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        User_Table: state.UserReducer.User_Table,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LViewAdmin))
);
